import React from 'react';
import ReactBellIcon from 'react-bell-icon';
import { Button } from 'react-bootstrap';

export default function OrderTouchNavigation(props) {
  const {
    setNumberPadNumber,
    setSelectedCompartment,
    setShowCustomerOrders,
    setShowNumberPad,
    tableCompartmentProducts,
    setTableTemp,
    ctxDispatch,
    alertColor,
    isCustomerOrder,
  } = props;
  return (
    <div style={{ width: '100%' }} className="d-grid ps-1 pe-1 mb-1">
      <div className="btn-group" role="group">
        <Button
          variant={!isCustomerOrder ? 'primary' : 'outline-secondary'}
          size="lg"
          onClick={(e) => {
            setShowCustomerOrders(false);
            setTableTemp(0);
            ctxDispatch({ type: 'SELECT_TABLE', payload: 0 });
          }}
        >
          <span>Salon</span> &nbsp;
          <i className="fas fa-home"></i>
        </Button>
        <Button
          size="lg"
          variant={isCustomerOrder ? 'primary' : 'outline-secondary'}
          onClick={(e) => {
            setTableTemp(0);
            ctxDispatch({ type: 'SELECT_TABLE', payload: 0 });
            setShowCustomerOrders(true);
          }}
        >
          <span>Müşteri</span> &nbsp;
          <ReactBellIcon
            active={alertColor ? true : false}
            animate={alertColor ? true : false}
            color={alertColor ? '#dc3545' : '#198754'}
            width="24"
            height="24"
          />
        </Button>

        <Button
          size="lg"
          variant="outline-secondary"
          onClick={(e) => {
            setNumberPadNumber(null);
            setShowNumberPad(true);
            if (tableCompartmentProducts.length === 0) {
              setSelectedCompartment(null);
            }
          }}
        >
          <span>123...</span>&nbsp;
          <i className="fas fa-hand-pointer-o " />
        </Button>
      </div>
    </div>
  );
}
